export const dataFieldsProduction = {
  Procedimento: {
    field: 'procedimento',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  CBO: {
    field: 'cbo',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Quantidade: 'quantidade',
}
export const dataFieldsMeta = {
  Categoria: 'categoria',
  Meta: 'meta',
  Produção: 'quantidade',
}
export const dataFieldsProfessional = {
  Profissional: 'no_prof',
  Produção: 'quantidade',
  Categoria: 'categoria',
}

export const infoHtml = ``
